import { render } from "./School.vue?vue&type=template&id=4ce55a08&scoped=true"
import script from "./School.vue?vue&type=script&lang=js"
export * from "./School.vue?vue&type=script&lang=js"

import "./School.vue?vue&type=style&index=0&id=4ce55a08&lang=scss&scoped=true"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce55a08"]])

export default __exports__